<template>
  <div>
    <input v-for="locationField in locationFields" :key="locationField" :value="location[locationField]" type="hidden" :name="getFullFieldName(locationField)">
  </div>
</template>

<script>
import difference from 'lodash/difference'

export default {
  props: {
    location: {
      type: Object,
      required: false
    },
    fieldGroupName: {
      type: String,
      required: false,
      default: 'location'
    }
  },

  computed: {
    locationFields() {
      return this.filteredLocationFields(this.location)
    }
  },

  methods: {
    getFullFieldName(name) {
      return `${this.fieldGroupName}[${name}]`
    },

    filteredLocationFields(location) {
      if (!location) {
        return []
      }

      const excludedFields = ['extra_location_info', 'boundary_box', 'errors']
      return difference(Object.keys(location), excludedFields)
    }
  }
}

</script>
